import React, {useEffect, useState} from "react";
import { useConfig } from "./ConfigContext";
import {useFirebase} from "@/hooks/useFirebase";
import { FirebaseModule, getAuth, getFirestore } from "@/utils/FirebaseUtils";


export const AuthContext = React.createContext({});

export const useAuth = () => React.useContext<any>(AuthContext);

export const AuthContextProvider = ({ children }: any) => {
  const [user, setUser] = useState<any>(null);
  const [showLoading, setShowLoading] = useState(true);
  const [modulesToLoad, setModulesToLoad] = useState<any>([]);
  const config = useConfig();

  const {
    firebase,
    loading
  } : any = useFirebase(config.firebase, modulesToLoad);


  useEffect(() => {
    const appAuthenticated : any = window.localStorage.getItem('app_authenticated');
    if(appAuthenticated == "true"){
      setModulesToLoad([FirebaseModule.AUTH, FirebaseModule.FIRESTORE]);
    }else{
      setShowLoading(false);
    }
  }, []);

  useEffect(() => {
    if(loading || !firebase || user != null){
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const redirectFrom = urlParams.get('redirect_from');

    let updatedProviders : any = {};

    if(redirectFrom == 'facebook'){
      const urlParamsFB = new URLSearchParams(window.location.href.split('?')[1].replace(new RegExp('#', 'g'), '&'));
      const expiresInStr = urlParamsFB.get('expires_in');
      const expiresIn = expiresInStr ? parseInt(expiresInStr) : 0;

      updatedProviders['facebook'] = {
        accessToken : urlParamsFB.get('access_token'),
        longLivedToken : urlParamsFB.get('long_lived_token'),
        expiresDate : new Date(new Date().getTime() + (expiresIn * 1000))
      }
    }
     
    const {auth} = getAuth(firebase);
    const {firestore, doc, getDoc, setDoc} = getFirestore(firebase);
    
    // TODO check if is logged into the auth object
    
    const unsubscribe = auth.onAuthStateChanged((loggedUser: any) => {
        console.log("ENTRO AQUI, AUTH CONTEXT, ON AUTH STATE CHANGED", loggedUser);
        if (loggedUser) {
          if(config.auth?.informationProvider == 'backend'){
            fetch(`${config.endpoints.backend}/user`, {
              headers: {
                'Authorization': `Bearer ${loggedUser.accessToken}`
              }
            })
            .then((response) => response.json()).then((response) => {
              setUser({
                ...loggedUser,
                data : response
              });

              setShowLoading(false);
            });
          }else{
            const docRef = doc(firestore, "users", loggedUser.email);
          getDoc(docRef).then((userInfo : any) => {
            let userInfoData = {
              roles : ['user'],
              providers : {}
            };

            if(!userInfo.exists()){
              // Create it
              setDoc(docRef, userInfoData).then(() => {
                setUser({
                  ...loggedUser,
                  data : userInfoData
                });

                setShowLoading(false);
              });

            }else{
              // @ts-ignore
              userInfoData = userInfo.data();

              if(Object.keys(updatedProviders).length){
                userInfoData = {
                  ...userInfoData,
                    providers : {
                      ...userInfoData.providers,
                      ...updatedProviders
                    }
                }

                setDoc(docRef, userInfoData).then(() => {
                  setUser({
                    ...loggedUser,
                    data : userInfoData
                  });
                  
                  // TODO REVISAR DE PONER ESTO ALGO MEJOR
                  window.location.href = window.location.href.split('?')[0];
                  setShowLoading(false);
                });
              }else{
                setUser({
                  ...loggedUser,
                  data : userInfoData
                });
                setShowLoading(false);
              }
            }
          });
          }          
      } else {
        setUser(null);
        setShowLoading(false);
      }
    });

    return () => unsubscribe();
  }, [loading, firebase]);

  return (
    <AuthContext.Provider value={{ user, showLoading, userInfo : user?.data }}>
      {children}
    </AuthContext.Provider>
  );
};